export default __webpack_public_path__ + "static/media/maze1Sample.da2b1643bcdf600bfeb064a2fea5bf3a.png";